import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';
import { MarkdownContent } from '@backstage/core-components';
import { configApiRef, useApi } from '@backstage/core-plugin-api';

// Backstage's frontend bundler replaces process.env.BUILD_INFO with an object.
// Keep this declaration module-local because Node environment values are strings.
declare const process: {
  env: {
    BUILD_INFO?: {
      gitVersion: string;
    };
  };
};

export function getDisplayedVersion(
  configuredVersion?: string,
  gitVersion?: string,
): string {
  return configuredVersion || gitVersion || 'development';
}

export function getHomeContent(version: string): string {
  return `
## Welcome to NeuSix IDP!

Version: ${version}

One stop shop for all devops needs.

Features:

- Tracking active & inactive services (Catalog)
- Environment Promotion & Overview (Deploy)

Coming Soon:

- Deploy Services in one click
- Deploy Postgres in one click
- Better logs
- Better overview
- Restart all services feature
- Audit log for all

`;
}

const HomeContent = () => {
  const configApi = useApi(configApiRef);
  const version = getDisplayedVersion(
    configApi.getOptionalString('app.version'),
    process.env.BUILD_INFO?.gitVersion,
  );

  return <MarkdownContent content={getHomeContent(version)} />;
};

const gettingStartedWidget = HomePageWidgetBlueprint.make({
  name: 'getting-started',
  params: {
    name: 'GettingStarted',
    title: 'News',
    description: 'Tips and links to help you get started with Backstage',
    components: async () => ({
      Content: HomeContent,
    }),
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [gettingStartedWidget],
});
